import { customFetch } from 'utils/http';
import { HTTPResponseError } from 'utils/errors';
import { getM8AuthURL } from 'services/production/utils/getM8URL';

export const refreshTokenURL = getM8AuthURL('refreshToken');

export const refreshToken = async () => {
  const response = await customFetch(
    refreshTokenURL,
    { method: 'POST' },
    false
  );

  if (!response.ok) {
    throw new HTTPResponseError(response);
  }
};
